export default __webpack_public_path__ + "9a0e6e5dc21ddccc4776cfbe43899995.woff2";